import { render, staticRenderFns } from "./dialog-alertWhatsapp.vue?vue&type=template&id=42f5fa18"
import script from "./dialog-alertWhatsapp.vue?vue&type=script&lang=js"
export * from "./dialog-alertWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports